<template>
  <header>
    <div class="header__wrapper">
      <a
        class="header__logo"
        href="/"
      >
        Choice
      </a>
      <nav
        v-if="showHeaderLinks"
        :class="{'header__links header__links--active': state.isMenuVisible,
                 'header__links': !state.isMenuVisible}
        "
      >
        <router-link
          to="quiz"
          :class="{'router-link-current-active': menuStore.quiz}"
          @click="state.isMenuVisible = !state.isMenuVisible"
        >
          Quiz
        </router-link>
        <router-link
          to="planner"
          :class="{'router-link-current-active': menuStore.planner}"
          @click="state.isMenuVisible = !state.isMenuVisible"
        >
          Planner
        </router-link>
      </nav>
      <a
        v-if="showHeaderLinks"
        href="#"
        :class="{
          'header__menu': !state.isMenuVisible,
          'header__menu header__menu--active': state.isMenuVisible
        }"
        @click.prevent="state.isMenuVisible = !state.isMenuVisible"
        @keyup.prevent.enter="state.isMenuVisible = !state.isMenuVisible"
      >
        Menu
      </a>
    </div>
  </header>
</template>
<script setup>
import { reactive } from 'vue';
import useMenuStore from '@/stores/menu';

const menuStore = useMenuStore();

const state = reactive({
  isMenuVisible: false,
  showHeaderLinks: false,
});
</script>
<style scoped lang="scss">
header {
  background: $colour_choice;
  vertical-align: middle;
  align-items: center;
  height: 64px;
  // position: fixed;
  width: 100%;
  // top: 0;
  // left: 0;
  // z-index: 2000;

  .header {
    &__wrapper {
      display: flex;
      align-items: center;
    }

    &__logo {
      display: block;
      background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/logo_choice.svg');
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      width: 124px;
      height: 64px;
      text-indent: -1000px;
    }

    &__text {
      a {
        font-size: 18px;
        line-height: 64px;
        color: white;
        padding-left: 12px;
        font-weight: bold;
        text-decoration: none;

        @include sml_breakpoint() {
          font-size: pxtorem(19px);
          padding-left: 16px;
        }
      }
    }

    &__wrapper {
      height: 64px;
      @include component-max-width;
    }

    &__menu {
      position: absolute;
      right: 0;
      top: 0;
      background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/icon_hamburger.svg');
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center center;
      height: 64px;
      width: 54px;
      text-indent: -9999px;
      transition: all 0.1s;
      &--active {
        background-image: url($VUE_APP_IMAGE_BASE_URL + '/images/icon_close.svg');
        background-size: 24px;
      }

      @include med-breakpoint() {
        display: none;
      }
    }

    &__links {
      position: absolute;
      top: 64px;
      left: 0;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      visibility: hidden;
      opacity: 0;
      transition: all 0.1s;

      &--active {
        visibility: visible;
        opacity: 1;
      }

      @include med-breakpoint() {
        visibility: visible;
        opacity: 1;
        position: relative;
        top: auto;
        left: auto;
        background: transparent;
        max-width: none;
        width: auto;
        flex-grow: 1;
        justify-content: flex-end;
        box-shadow: 0 0 0 0;
        flex-direction: row;
      }

      a {
        font-size: pxtorem(16px);
        line-height: pxtorem(24px);
        padding: pxtorem(12px) pxtorem(16px);
        color: #002E46;
        font-weight: bold;
        text-decoration: none;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;

        &:last-child {
          margin-right: 0;
        }

        @include med-breakpoint() {
          border-style: solid;
          border-color: transparent;
          line-height: 52px;
          border-width: 6px 0;
          margin-right: 20px;
          color: white;
          padding: 0;
          font-size: pxtorem(19px);
          background: transparent;
        }

        &.router-link-active,
        &.router-link-current-active,
        &:hover {
          color: $colour_choice_blue;
          background-color: #F6F6F6;

          @include med-breakpoint() {
            color: white;
            border-bottom-color: #fff;
            background: transparent;
          }
        }

        // &.router-link-active:nth-child(2) {
        //   color: $colour_choice_blue;
        //   background-color: #F6F6F6;

        //   @include med-breakpoint() {
        //     border-bottom-color: #fff;
        //     background: transparent;
        //     color: white;
        //   }
        // }
      }
    }
  }
}
</style>
